import { render } from "./UpdateVpnCustomerGateway.vue?vue&type=template&id=079540ee"
import script from "./UpdateVpnCustomerGateway.vue?vue&type=script&lang=js"
export * from "./UpdateVpnCustomerGateway.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__